import * as React from 'react';
import clsx from 'clsx';

import { ISharedComponentProps } from './shared-props';

/* eslint-disable-next-line */
export interface IAnchorLinkButtonProps extends React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>, ISharedComponentProps {}

export const AnchorLinkButton = ({
    icon: Icon,
    label,
    active = false,
    className,
    colorIcon = true,
    ...rest
}: IAnchorLinkButtonProps) => {
    const renderLabel = () => {
        if (label) {
            return (
                <div className='component-label'>
                    {label}
                </div>
            );
        } else {
            return null;
        }
    };

    const renderIcon = () => {
        if (Icon) {
            return (
                <div className='component-icon'>
                    {React.cloneElement(Icon, {
                        className: clsx(Icon.props.className, 'interactable-icon')
                    })}
                </div>
            );
        } else {
            return null;
        }
    };

    return (
        <a
            className={clsx('interactable-icon-wrapper', 'anchor-button', className, {
                'active': active,
                'no-label': !label,
                'no-icon': !Icon,
                'color-icon': colorIcon
            })}
            {...rest}
        >
            {renderIcon()}
            {renderLabel()}
        </a>
    );
};
